module.exports = "<div class=\"wrapper\">\n    <div class=\"button_container\">\n        <a mat-raised-button color=\"primary\" href=\"https://www.adcolombia.org/\" target=\"_blank\">IR A ASAMBLEAS DE DIOS</a>\n    </div>\n    <router-outlet></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin.component.html
// module id = ./src/app/admin/admin.component.html
// module chunks = main